import fetchJSON from '../fetchJSON';
import { API_VERSION } from '../config';

const ALLOWED_METHODS = [
  'GET',
  'POST',
  'PUT',
  'PATCH',
  'HEAD',
  'OPTIONS',
  'DELETE',
];


export default async function callWebApi(method, url, body, authToken) {
  if (!ALLOWED_METHODS.includes(method)) {
    throw new TypeError(`callWebApi invalid argument: method=${method} is invalid`);
  }
  if (url.search(/\{\w+\}/) >= 0) {
    throw new TypeError(`callWebApi invalid argument: url=${url} contains a placeholder`);
  }
  return fetchJSON(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: authToken ? `Bearer ${authToken}` : undefined,
      'X-Api-Version': API_VERSION,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
}



// WEBPACK FOOTER //
// ./src/actions/callWebApi.js